'use strict';

var _ = require('lodash');
var SimpleGridRenderersService = function SimpleGridRenderersService(faresOptimizerConstants) {
  var RENDERERS = {
    'cell_color_percent': function cell_color_percent(value, row) {
      return getPercentageStyling(value, row);
    },
    'link_renderer': function link_renderer(value, row, groupIndex) {
      return getLinkRenderer(value, row, groupIndex);
    },
    'checkbox': function checkbox(value, row) {
      return getCheckBoxRenderer(value, row);
    },
    'row_selection_checkbox': function row_selection_checkbox(groupIndex, isChecked, row) {
      return getRowLevelCheckBoxRenderer(groupIndex, isChecked, row);
    }
  };
  function getCheckBox(el) {
    return '<label class="chkboxin">' + el + '<span class="labelchkbox"></span></label>';
  }
  function getRowLevelCheckBoxRenderer(groupIndex, isChecked, row) {
    if (row.isShowCheckedAndDisabled === true) {
      return getCheckBox('<input type="checkbox" data-group-index="' + groupIndex + '" checked="checked" disabled class="group-select-checkbox">');
    } else if (isChecked === true) {
      if (row.isSelectionDisabled === true) {
        return getCheckBox('<input type="checkbox" data-group-index="' + groupIndex + '" checked="checked" disabled class="group-select-checkbox">');
      } else {
        return getCheckBox('<label class="chkboxin"><input type="checkbox" data-group-index="' + groupIndex + '" checked="checked" class="group-select-checkbox">');
      }
    } else {
      if (row.isSelectionDisabled === true) {
        return getCheckBox('<input type="checkbox" data-group-index="' + groupIndex + '" disabled class="group-select-checkbox">');
      } else {
        return getCheckBox('<input type="checkbox" data-group-index="' + groupIndex + '" class="group-select-checkbox">');
      }
    }
  }
  function getCheckBoxRenderer(value, row) {
    var checkbox;
    var checked = row.useForLadderGenerationInd;
    var toBeEnabled = isCheckBoxToBeEnabled(row);
    if (toBeEnabled) {
      checkbox = getAppropriateCheckBox(checked, value);
    } else {
      checkbox = '<label class="chkboxin"> <input type="checkbox" class="custom-checkbox" value="' + value + '" checked disabled > <span class="labelchkbox"></span> </label>';
    }
    return checkbox;
  }
  function isCheckBoxToBeEnabled(row) {
    return row.inventoryAssignmentMethod === 'RBD TO RBD';
  }
  function getAppropriateCheckBox(checked, value) {
    var checkbox;
    if (checked) {
      checkbox = '<label class="chkboxin"> <input type="checkbox" class="custom-checkbox" value="' + value + '" checked > <span class="labelchkbox"></span> </label>';
    } else {
      checkbox = '<label class="chkboxin"> <input type="checkbox" class="custom-checkbox" value="' + value + '" > <span class="labelchkbox"></span> </label>';
    }
    return checkbox;
  }
  function getLinkRenderer(value, row, groupIndex) {
    return isRenderLink(value, row) ? '<button type="button"  class="btn btn-default btn-link link-render" data-group-index="' + groupIndex + '">' + value + '</button>' : value;
  }
  function isRenderLink(value, row) {
    return value === faresOptimizerConstants.FAILED || value === faresOptimizerConstants.NEW && (row.isAutoApprovable === false || row.isRecommendationCapped) || value === faresOptimizerConstants.NO_RECOM || value === faresOptimizerConstants.REJECTED || value === faresOptimizerConstants.APPROVED || value === faresOptimizerConstants.PENDING && !_.isNil(row.remarks) && (row.remarks === faresOptimizerConstants.VALID || row.remarks === faresOptimizerConstants.INVALID);
  }
  function getRendererFor(renderId) {
    return RENDERERS[renderId];
  }
  function getPercentageStyling(fareChangePercentage, row) {
    var MIN_BAR_WIDTH = 10;
    function getPercentageBarWidth(row) {
      var roundedMax = Math.round(row.maxFareChange * 100);
      var roundedChange = Math.round(row.fareChangePercentage * 100);
      var normalizedPercentage = roundedMax !== 0 ? roundedChange / roundedMax : 0;
      return Math.round(Math.abs(normalizedPercentage) * (100 - MIN_BAR_WIDTH));
    }
    var scaledWidth = getPercentageBarWidth(row);
    var calculatedWidth = scaledWidth !== 0 ? MIN_BAR_WIDTH + scaledWidth : 0;
    if (row.fareChangePercentage !== 0) {
      return '<span class="fare-percent-change-wrap" style="background-size: ' + calculatedWidth + '% 100%">' + fareChangePercentage + '</span>' + '<span class="fare-change-width-placeholder">' + fareChangePercentage + '</span>';
    } else {
      return '<span class="fare-percent-change-wrap" style="background-size: ' + calculatedWidth + '% 100%">' + 0 + '</span>' + '<span class="fare-change-width-placeholder">' + fareChangePercentage + '</span>';
    }
  }
  return {
    getRendererFor: getRendererFor
  };
};
SimpleGridRenderersService.$inject = ['FaresOptimizerConstants'];
module.exports = SimpleGridRenderersService;